import { AppBar as RAAppBar, TitlePortal, useTheme } from "react-admin";
import { Box, useMediaQuery } from "@mui/material";

import { logo, logoBlack } from "../assets/images";

const AppBar = () => {
  const isLargeEnough = useMediaQuery((theme) => theme.breakpoints.up("sm"));
  const [theme] = useTheme();

  return (
    <RAAppBar color="secondary" elevation={1}>
      <TitlePortal />
      {isLargeEnough && (
        <img
          src={theme === "light" ? logoBlack : logo}
          alt="Morfy"
          height={35}
          width={126}
        />
      )}
      {isLargeEnough && <Box component="span" sx={{ flex: 1 }} />}
    </RAAppBar>
  );
};

export default AppBar;
